export const LoadingSpinner = () => {
  return (
    <div className="w-full max-w-2xl mx-auto p-6 flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Loading form...</p>
      </div>
    </div>
  );
};
